import './PillarSection.css';
import Pillar from './Pillar.js';
import React from "react";

function PillarSection(props) {
    return (
        <div className="pillarSection">
            <p className="pillarSidewaysText"> my pillars support my goals </p>
            <div className="pillarLine upperPillarLine"></div>
            <div className="pillarLine lowerPillarLine"></div>
            <div className="pillarRow">
                {props.userProfile.pillars.map((pillar, index) => (
                    <Pillar key={index} title={pillar.title} glowPercent={pillar.glowPercent} />
                ))}
            </div>
        </div>
    )
}

export default PillarSection;